export const MODULE_DISPLAY_NAMES = {
  localdb: "Yivo",
  abuseipdb: "AbuseIPDB",
  virustotal: "VirusTotal",
  greynoise: "GreyNoise",
  shodan: "Shodan",
  urlhaus: "URLhaus",
  onionoo: "Onionoo",
  whois: "Whois",
  threatfox: "ThreatFox"
};